// Generated by purs version 0.13.5
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Items = require("../Items/index.js");
var Node_Path = require("../Node.Path/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Events = require("../React.Basic.DOM.Events/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var WebApp_Gallery_Modal = require("../WebApp.Gallery.Modal/index.js");
var WebApp_Gallery_ZoomSlider = require("../WebApp.Gallery.ZoomSlider/index.js");
var cleanupName = (function () {
    var $27 = Data_String_Common.replaceAll("-")(" ");
    var $28 = Data_String_Common.replaceAll("_")(" ");
    return function ($29) {
        return $27($28($29));
    };
})();
var renderItems = function (self) {
    return function (v) {
        if (v instanceof Items.Category) {
            var isItem = function (v1) {
                if (v1 instanceof Items.Item) {
                    return true;
                };
                if (v1 instanceof Items.Category) {
                    return false;
                };
                throw new Error("Failed pattern match at WebApp.Gallery (line 78, column 14 - line 80, column 26): " + [ v1.constructor.name ]);
            };
            var v1 = Data_Array.partition(isItem)(v.value0.items);
            var sorted = Data_Array.concat([ v1.yes, v1.no ]);
            var $13 = Data_Array["null"](v1.yes);
            if ($13) {
                return React_Basic_DOM_Generated.div()({
                    className: "row",
                    id: v.value0.path,
                    children: Data_Functor.map(Data_Functor.functorArray)(renderItems(self))(v1.no)
                });
            };
            return React_Basic.fragment([ React_Basic_DOM_Generated.div()({
                className: "row"
            }), React_Basic_DOM_Generated.div()({
                className: "row card-panel brown lighten-5",
                style: React_Basic_DOM.css({
                    margin: "15px",
                    borderRadius: "15px"
                }),
                children: [ React_Basic_DOM_Generated.h5()({
                    id: v.value0.path,
                    className: "brown lighten-1",
                    style: React_Basic_DOM.css({
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        padding: "10px"
                    }),
                    children: Data_Functor.map(Data_Functor.functorArray)(function (p) {
                        return React_Basic_DOM_Generated.span()({
                            className: "breadcrumb",
                            children: [ React_Basic_DOM.text(cleanupName(p)) ]
                        });
                    })(Data_String_Common.split("/")(v.value0.path))
                }), React_Basic.fragment(Data_Functor.map(Data_Functor.functorArray)(renderItems(self))(sorted)) ]
            }) ]);
        };
        if (v instanceof Items.Item) {
            var image = Data_Maybe.maybe("data:image/svg+xml;charset=UTF-8,%3csvg width='112' height='99' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke-width='2' stroke='%23CBCBC9' fill='none' fill-rule='evenodd' opacity='.7'%3e%3cpath d='M111 95L80.9997013 43 56 81.1326499 31.0002987 60.3333333 1 95'/%3e%3cpath d='M1 98h110V1H1z'/%3e%3cpath d='M49 33c0 6.6314752-5.3685248 12-12 12-6.62359 0-12-5.3685248-12-12 0-6.62359 5.37641-12 12-12 6.6314752 0 12 5.37641 12 12z'/%3e%3c/g%3e%3c/svg%3e ")(function (v1) {
                return Node_Path.concat([ v1.dirname, v1.basename ]);
            })(v.value0.previewImage);
            return React_Basic_DOM_Generated.div()({
                className: "col",
                children: [ React_Basic_DOM_Generated.div()({
                    className: "card",
                    style: React_Basic_DOM.css({
                        width: Data_Show.show(Data_Show.showInt)(self.state.cellSize) + "px"
                    }),
                    children: [ React_Basic_DOM_Generated.div()({
                        className: "card-image",
                        children: [ React_Basic_DOM_Generated.img()({
                            src: image,
                            title: "Click to enlarge",
                            onClick: React_Basic_DOM_Events.capture_(self.setState(function (v1) {
                                return {
                                    cellSize: v1.cellSize,
                                    showModal: new Data_Maybe.Just({
                                        label: v.value0.label,
                                        files: v.value0.files
                                    })
                                };
                            }))
                        }) ]
                    }), React_Basic_DOM_Generated.div()({
                        className: "card-content",
                        children: [ React_Basic_DOM_Generated.span()({
                            className: "card-title",
                            style: React_Basic_DOM.css({
                                textTransform: "capitalize",
                                fontSize: "18px"
                            }),
                            children: [ React_Basic_DOM.text(cleanupName(v.value0.label)) ]
                        }), React_Basic_DOM_Generated.div()({
                            style: React_Basic_DOM.css({
                                borderTop: "1px solid black",
                                marginTop: "15px",
                                padding: "10px 0px 10px 0"
                            }),
                            children: Data_Array_NonEmpty.toArray(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(function (file) {
                                var ext = Node_Path.extname(file.basename);
                                return React_Basic_DOM_Generated.a()({
                                    className: "col",
                                    style: React_Basic_DOM.css({
                                        marginLeft: "-.3em",
                                        marginRight: "-.3em",
                                        textTransform: "uppercase"
                                    }),
                                    href: Node_Path.concat([ file.dirname, file.basename ]),
                                    download: file.basename,
                                    children: [ React_Basic_DOM.text(ext) ]
                                });
                            })(v.value0.files))
                        }) ]
                    }) ]
                }) ]
            });
        };
        throw new Error("Failed pattern match at WebApp.Gallery (line 55, column 1 - line 55, column 36): " + [ self.constructor.name, v.constructor.name ]);
    };
};
var gallery = (function () {
    var render = function (self) {
        return React_Basic.fragment([ WebApp_Gallery_ZoomSlider.zoomSlider({
            value: self.state.cellSize,
            min: 200,
            max: 500,
            onChange: function (v) {
                return self.setState(function (v1) {
                    return {
                        cellSize: v,
                        showModal: v1.showModal
                    };
                })();
            }
        }), WebApp_Gallery_Modal.modal({
            showModal: self.state.showModal,
            onClick: React_Basic_DOM_Events.capture_(self.setState(function (s) {
                return {
                    cellSize: s.cellSize,
                    showModal: Data_Maybe.Nothing.value
                };
            }))
        }), renderItems(self)(self.props.items) ]);
    };
    var initialState = {
        cellSize: 260,
        showModal: Data_Maybe.Nothing.value
    };
    return React_Basic.make()(React_Basic.createComponent("Gallery"))({
        initialState: initialState,
        render: render
    });
})();
module.exports = {
    gallery: gallery,
    renderItems: renderItems,
    cleanupName: cleanupName
};
